import { AuditUser } from "./auditUser"

export enum LayoutType {
	Email
}

export interface LayoutSection {
    key: string
    title: string
    supportsTitle: boolean
}

export interface Layout {
    id: string
    title: string
    applicableTypes: LayoutType[]
    sections: LayoutSection[]
}

export interface FormatSection {
    title: string
    layoutSection: string
    template: string
}

export interface Format {
    id: string | null
    title: string
    layout: string | null
    layoutType: LayoutType
    dateFormat: string
    timeZone: string
    created?: string | null
    createdBy?: AuditUser
	sections: FormatSection[]
}
